
namespace Gamification.Gamification {
    export class TipologieEsperienzeColumns {
        static columnsKey = 'Gamification.TipologieEsperienze';
    }
}